import { FC, ReactNode } from 'react';
import classnames from 'classnames';
import styles from './button.module.scss';
import { Button, ButtonProps, Form } from 'rsuite';
import { RsButtonSize, sizeMap } from './size';

interface MyButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: ButtonProps['className'];
  size?: RsButtonSize;
  appearance?: ButtonProps['appearance'];
  color?: ButtonProps['color'];
  loading?: boolean;
  errorMessage?: string;
  disabled?: boolean;
}

export const RsButton: FC<MyButtonProps> = ({
  children,
  onClick = () => {},
  className = '',
  appearance = 'default',
  color = undefined,
  loading = false,
  disabled = false,
  errorMessage = undefined,
  size = RsButtonSize.SMALL,
}) => {
  return (
    <div className='rs-form-control-wrapper'>
      <Button
        className={classnames(styles.RsButton, sizeMap[size], className)}
        onClick={onClick}
        appearance={appearance}
        color={color}
        loading={loading}
        disabled={disabled}
      >
        {children}
      </Button>
      <Form.ErrorMessage
        show={errorMessage !== undefined}
        placement='bottomStart'
      >
        {errorMessage}
      </Form.ErrorMessage>
    </div>
  );
};
